import { render, staticRenderFns } from "./QuestionnaireStep4Cpt.vue?vue&type=template&id=62c9cfb0&scoped=true&"
import script from "./QuestionnaireStep4Cpt.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireStep4Cpt.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireStep4Cpt.vue?vue&type=style&index=0&id=62c9cfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c9cfb0",
  null
  
)

export default component.exports